import { t } from 'i18next';

import { DiscaredStatus } from '@/modules/ContactsModule/types/Contacts';

interface Filters {
  rank: {
    [key: string]: string;
  };
  geolocation: {
    [key: string]: string;
  };
  devices: {
    [key: string]: string;
  };
  socialNetworks: {
    [key: string]: string;
  };
  channels: {
    [key: string]: string;
  };
  discardedGroup: Record<string, DiscaredStatus>;
}

/* cspell:disable */
const filters: Filters = {
  rank: {
    1: 'discarded',
    2: 'inactive',
    3: 'new',
    4: 'frequent',
    5: 'asleep',
  },
  geolocation: {
    AF: 'Afghanistan',
    AX: 'Aland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia, Plurinational State of',
    BQ: 'Bonaire, Saint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, The Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: 'Cote d Ivoire',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curacao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Malvinas Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'Korea, Democratic Peoples Republic of',
    KR: 'Korea, Republic of',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Lao Peoples Democratic Republic',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyan Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia, The Former Yugoslav Republic of',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States of',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    PS: 'Palestinian Territory',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthelemy',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (French part)',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and The Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Dutch part)',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan, Province of China',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela, Bolivarian Republic of',
    VN: 'Viet Nam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.S.',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
  devices: {
    1: 'desktop',
    2: 'mobile',
    3: 'tablet',
  },
  socialNetworks: {
    1: 'Twitter',
    2: 'Facebook',
    3: 'Linkedin',
  },
  channels: {
    1: 'Email',
    2: 'Push',
    3: 'SMS',
  },
  discardedGroup: {
    Suspendidos: 'suspended',
    Inseguros: 'unsafe',
    Denunciantes: 'complainers',
    Cuarentena: 'quarantine',
    Desuscripto: 'unsubscribe',
    'Lista negra': 'blocked',
  },
};
/* cspell:enabled */

export type NameFilters =
  | 'rank'
  | 'geoLocation'
  | 'devices'
  | 'socialNetworks'
  | 'channels'
  | 'discardedGroup'
  | 'gender'
  | 'eCommerceClassification';

export enum NameFilterEnum {
  rank = 'rank',
  geolocation = 'geoLocation',
  devices = 'devices',
  socialNetworks = 'socialNetworks',
  channels = 'channels',
  discardedGroup = 'discardedGroup',
  eCommerceClassification = 'eCommerceClassification',
  gender = 'gender',
}

export const WrappingFilters = (nameFilter: NameFilters, values: string[]): string[] => {
  const wrappFilter = values.map((name: string) => {
    if (nameFilter === NameFilterEnum.rank) {
      if (Object.prototype.hasOwnProperty.call(filters.rank, name)) {
        return t(`STATUS_FILTER.${filters.rank[name]}`);
      }
    } else if (nameFilter === NameFilterEnum.geolocation) {
      if (Object.prototype.hasOwnProperty.call(filters.geolocation, name)) {
        return filters.geolocation[name];
      }
    } else if (nameFilter === NameFilterEnum.gender) {
      return name.toLowerCase() === 'f'
        ? t('SEGMENTS_CONDITIONS.female')
        : t('SEGMENTS_CONDITIONS.male');
    } else if (nameFilter === NameFilterEnum.devices) {
      if (Object.prototype.hasOwnProperty.call(filters.devices, name)) {
        return t(`SEGMENTS_CONDITIONS.${filters.devices[name]}`);
      }
    } else if (nameFilter === NameFilterEnum.socialNetworks) {
      if (Object.prototype.hasOwnProperty.call(filters.socialNetworks, name)) {
        return filters.socialNetworks[name];
      }
    } else if (nameFilter === NameFilterEnum.channels) {
      if (Object.prototype.hasOwnProperty.call(filters.channels, name)) {
        return filters.channels[name];
      }
    } else if (nameFilter === NameFilterEnum.discardedGroup) {
      if (Object.prototype.hasOwnProperty.call(filters.discardedGroup, name)) {
        return t(`STATUS_FILTER.${filters.discardedGroup[name]}`);
      }
    } else if (nameFilter === NameFilterEnum.eCommerceClassification) {
      return t(`PROFILE_ECOMMERCE_TABLE.${name}`);
    } else {
      return '';
    }
  }) as string[];

  return wrappFilter;
};
